import { Children, CSSProperties, PropsWithChildren } from 'react'
import Styles from './Stackable.module.scss'
import { StackableCard } from 'components/Stackable/StackableCard'
import { useMeasure } from 'react-use'
import cx from 'classnames'

interface Props {
  className?: string
}

export const Stackable = ({ children, className }: PropsWithChildren<Props>) => {
  const childrenArray = Children.toArray(children)
  const [ref, { height: firstCardHeight }] = useMeasure<HTMLDivElement>()

  return (
    <div
      className={cx(Styles.root, className)}
      style={
        {
          '--stack-length': childrenArray.length,
          '--stack-offset': `${firstCardHeight}px`,
        } as CSSProperties
      }
    >
      <div className={Styles.content}>
        {childrenArray.map((child, index) => (
          <StackableCard
            stackLength={childrenArray.length}
            offset={firstCardHeight}
            key={index}
            position={index + 1}
            ref={index === 0 ? ref : undefined}
          >
            {child}
          </StackableCard>
        ))}
      </div>
    </div>
  )
}
